export default 'USER_CLICKED_STOP';
